import { Component, OnInit, Renderer2, ElementRef , ChangeDetectorRef, ViewChild, TemplateRef} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlogService } from './blog.service';
import { ApiService } from '@root/shared/services/api.service';
import { Urls } from '@root/utils/urls';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { DownloadFileService } from '@root/shared/services/download-file.service';
import { CommonDataService } from '@root/shared/services/common-data.service';
import { Something_went_wrong } from '@root/app.constant';


declare var $: any; // For using jQuery plugins

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss']
})
export class BlogsComponent implements OnInit {
  @ViewChild('videoRow', { static: false }) videoRow!: ElementRef;
  @ViewChild('infoRow', { static: false }) infoRow!: ElementRef;
  @ViewChild('readRow', { static: false }) readRow!: ElementRef;

 
  BannerList:any[]
  videoList:any[]
  infographicList:any[]
  blogList:any[]
  modalTarget:string ='#infographics-modal'
  showArrow: boolean;
  organizedSections:any;

  showVideoPopup = false;
  videoId = '';
  loadingVideo = true;
  isShort:boolean


  
  
  constructor( private router:Router,  private modalService:NgbModal, private blogService:BlogService, private apiService:ApiService, private toastr:ToastrService,private downloadFileService:DownloadFileService,private commonDataService:CommonDataService) { }
  activeTab: string = 'watch';
  formData = {
    name: "",
    emailId: "",
    mobileNumber: "",
    comment: "",
  };
  
  ngOnInit(): void {
    this.commonDataService.loaderStatus.next(true);
    this.apiService.getData(Urls.getIapPageTextForAllSections).subscribe(
      (response) => {
        console.log(response)
        
        if (response && response.data.returnValueList) {
      this.organizedSections = {};

      // Iterate through each item in returnValueList
      response.data.returnValueList.forEach((item: any) => {
        const sectionName = item.sectionName;
        this.organizedSections[sectionName] = item;
      });
        }
        this.commonDataService.loaderStatus.next(false);
      },
      (error) => {
        this.showArrow =  false;
        if(error.error.errorMessage === null || error.errorMessage === '') {
          this.toastr.error(Something_went_wrong);
        }else {
          this.toastr.error(error.error.errorMessage);
        }
        this.commonDataService.loaderStatus.next(false);

      }
    );
    this.blogService.setActiveTab(this.activeTab)
    this.getBanners()
    this.getVideos()

  }

  backToHome(){
    this.router.navigate(['/home'], {
      state: { previousUrl: this.router.url },
    });
  }

  
  goToSection(divId: string): void {
    const element = document.getElementById(divId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  scrollRight(): void {
    if(this.activeTab ==='watch'){
      const videoRowEl = this.videoRow.nativeElement as HTMLElement;
      const scrollAmount = videoRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
      videoRowEl.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
    else if(this.activeTab ==='infographics'){
      const infoRowEl = this.infoRow.nativeElement as HTMLElement;
      const scrollAmount = infoRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
      infoRowEl.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
    else{
      const readRowEl = this.readRow.nativeElement as HTMLElement;
      const scrollAmount = readRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
      readRowEl.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
   
  }

  scrollLeft(): void {
    if(this.activeTab ==='watch'){
      const videoRowEl = this.videoRow.nativeElement as HTMLElement;
      const scrollAmount = videoRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
      videoRowEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
    else if(this.activeTab ==='infographics'){
      const infoRowEl = this.infoRow.nativeElement as HTMLElement;
      const scrollAmount = infoRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
      infoRowEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
    else{
      const readRowEl = this.readRow.nativeElement as HTMLElement;
      const scrollAmount = readRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
      readRowEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
    // const blogsRowEl = this.blogsRow.nativeElement as HTMLElement;
    // const scrollAmount = blogsRowEl.firstElementChild.clientWidth || 0; // Scroll by the width of one video
    // blogsRowEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  }
 
  extractYoutubeVideoId(url: string): string | null {
    try {
      const parsedUrl = new URL(url);
  
      // Handle youtu.be short links
      if (parsedUrl.hostname.includes("youtu.be")) {
        this.isShort = false
        return parsedUrl.pathname.slice(1);
      }
  
      // Handle Shorts
      if (parsedUrl.pathname.startsWith("/shorts/")) {
        this.isShort = true
        return parsedUrl.pathname.split("/")[2] || parsedUrl.pathname.split("/")[1];
      }
  
      // Handle regular watch?v=
      const videoId = parsedUrl.searchParams.get("v");
      this.isShort = false
      if (videoId) return videoId;
  
      // Handle embed
      if (parsedUrl.pathname.startsWith("/embed/")) {
        this.isShort = false
        return parsedUrl.pathname.split("/")[2];
      }
  
      return null;
    } catch (error) {
      console.error("Invalid YouTube URL:", url);
      return null;
    }
  }
  

  async generateThumbnail(video) {
    const videoId = this.extractYoutubeVideoId(video.youtubeLink);
    if (!videoId){
      // this.toastr.error('Invalid YouTube URL. Please try with a valid video link.');
      return;
    } 
  
    const resolutions = ["maxresdefault", "hqdefault", "mqdefault", "default"];
    let foundThumbnail = false;
  
    for (let res of resolutions) {
      const url = `https://img.youtube.com/vi/${videoId}/${res}.jpg`;
  
      try {
        const response = await fetch(url, { method: "HEAD" }); // Check if image exists
        if (response.ok) {
          video.thumbnail = url;  // Assign the first valid image
          foundThumbnail = true;
          return;
        }
      } catch (error) {
        console.error(`Failed to fetch ${url}`, error);
      }
    }
  
    // If no valid thumbnail is found, set to maxresdefault as the last resort
    if (!foundThumbnail) {
      video.thumbnail = 'assets/images/default-video-placeholder.jpg';
    }
  }

  openModal(content:TemplateRef<any>) {
    this.modalService.open(content, {
      size: "lg",
      windowClass: "align-modal-center custom-modal-width",
    });

  }

  onTabChange(tabId: string): void {
    this.activeTab = tabId;
  this.blogService.setActiveTab(tabId);
    if(  this.activeTab==='watch'){
      this.getVideos()
    }
    else if(this.activeTab==='infographics'){
      this.getInfographics()
    }
    else if(this.activeTab==='read'){
      this.getBlogs()

    }

  }

  viewAllBlogs(){
    this.router.navigate(['/blogs/view-all', this.activeTab]);
  }

  closePopup(modal: any) {
    modal.close();  // Close the modal
  }

  getBanners(){
    this.commonDataService.loaderStatus.next(true);
    this.apiService.getData(Urls.getIapPageBanners).subscribe(
      (response) => {
        this.BannerList = response.data.banners;
        this.commonDataService.loaderStatus.next(false);
      },
      (error) => {
        if(error.error.errorMessage === null || error.errorMessage === '') {
          this.toastr.error(Something_went_wrong);
        }else {
          this.toastr.error(error.error.errorMessage);
        }
        this.commonDataService.loaderStatus.next(false);
      }
    );
  }

  getVideos(){
    this.commonDataService.loaderStatus.next(true);
    this.apiService.getData(Urls.getIapPageVideos).subscribe(
      (response) => {
        this.videoList = response.data.videos;
        this.showArrow = this.videoList && this.videoList.length > 3 || false;
        // this.videoList.map(video=>{
        //   this.generateThumbnail(video)
        // })
        this.commonDataService.loaderStatus.next(false);
      },
      (error) => {
        this.showArrow =  false;
        if(error.error.errorMessage === null || error.errorMessage === '') {
          this.toastr.error(Something_went_wrong);
        }else {
          this.toastr.error(error.error.errorMessage);
        }
        this.commonDataService.loaderStatus.next(false);

      }
    );
  }
  getInfographics(){
    this.commonDataService.loaderStatus.next(true);
    this.apiService.getData(Urls.getIapPageInfographics).subscribe(
      (response) => {
        this.infographicList = response.data.infographics;
        this.showArrow = this.infographicList && this.infographicList.length > 3 || false;
        this.commonDataService.loaderStatus.next(false);
      },
      (error) => {
        this.showArrow =  false;
        if(error.error.errorMessage === null || error.errorMessage === '') {
          this.toastr.error(Something_went_wrong);
        }else {
          this.toastr.error(error.error.errorMessage);
        }
        this.commonDataService.loaderStatus.next(false);

      }
    );
  }
  getBlogs(){
    this.commonDataService.loaderStatus.next(true);
    this.apiService.getData(Urls.getIapPageBlogs).subscribe(
      (response) => {
        this.blogList = response.data.blogs; 
        this.showArrow = this.blogList && this.blogList.length > 3 || false;
        console.log(this.showArrow)
        this.commonDataService.loaderStatus.next(false); 
      },
      (error) => {
        this.showArrow =  false;
        if(error.error.errorMessage === null || error.errorMessage === '') {
          this.toastr.error(Something_went_wrong);
        }else {
          this.toastr.error(error.error.errorMessage);
        }
        this.commonDataService.loaderStatus.next(false);
      }
    );
  }
  
  viewBlogPage(id:any){
    this.router.navigate(['/blogs/view', id]);
  }

  redirectToSocialMedia(shareIcon: number, file: any): void {
    const imageUrl = file; 
    const text = "Check out this!\n";
  
    let url = "";
  
    switch (shareIcon) {
      case 1: // Facebook
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          imageUrl
        )}`;
        break;
  
      case 2: // Instagram
        url = "https://www.instagram.com/"; 
        break;
  
      case 3: // Twitter
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          text
        )}&url=${encodeURIComponent(imageUrl)}`;
        break;
  
      case 4: // WhatsApp
        url = `https://wa.me/?text=${encodeURIComponent(
          text + " " + imageUrl
        )}`;
        break;
  
      default:
        url = "";
    }
  
    if (url) {
      window.open(url, "_blank");
    }
  }
  

  submitForm(form: NgForm) {
    if (form.invalid) {
      alert("Please fill all the required fields correctly.");
      return; 
    }

    this.commonDataService.loaderStatus.next(true);
    this.apiService.postData(Urls.knowMoreAboutMF, this.formData).subscribe(
      (response) => {
        // this.toastr.success("Form submitted successfully");
        this.toastr.info(
          response.message,
          "",
          {
            enableHtml: true,
            timeOut: 5000,
          }
        );
        this.commonDataService.loaderStatus.next(false);
        form.resetForm();
      },
      (error) => {
        if(error.error.errorMessage === null || error.errorMessage === '') {
          this.toastr.error(Something_went_wrong);
        }else {
          this.toastr.error(error.error.errorMessage);
        }
        this.commonDataService.loaderStatus.next(false);

       
      }
    );
  }


  public downloadFile(path:string){
    const fileName = path.split("/").pop();
    this.downloadFileService.export(path).subscribe(
      path => saveAs(path,fileName)
    );
   } 
   viewClickableUrlPage(clickableUrl:any){
   if(clickableUrl && clickableUrl.length >0 && clickableUrl!=='null'){
      const isRelativePath = clickableUrl.indexOf('http')===-1;
      isRelativePath ? this.router.navigateByUrl(clickableUrl) :  window.open(clickableUrl, "_blank");
    }
   }

   openVideo(youtubeUrl: string) {
    const videoId = this.extractYoutubeVideoId(youtubeUrl);
    if (!videoId) {
      this.toastr.error('Invalid YouTube URL. Please try with a valid video link.');
      return;
    }
    this.videoId = videoId;
    this.loadingVideo = true;
    this.showVideoPopup = true;
  }

  onPlayerReady(event: YT.PlayerEvent) {
    console.log('ready')
    this.loadingVideo = false;
    const player = event.target;
    player.mute(); // Required for autoplay in most browsers
    player.playVideo();
  }

  closeVideo() {
    this.showVideoPopup = false;
    this.videoId = '';
    this.loadingVideo = false;
  }

}
